import Media from './../mediaDetect.js'; //Детектор медиа
import Switcher from './switcher.js';
import Pulpmill from './pulpmill.js';

let Nav = {
    closeMobileMenu: function(){
        var menu = $('[data-header-mobile-menu]');

        if(menu.hasClass('nav-mobile_open')){
            menu.removeClass('nav-mobile_open');
        }
        $('[data-header]').removeClass('open');
        $('body').removeClass('menu-opened');
        menu.find('[data-header-menu-link].active').removeClass('active');
        menu.find('[data-header-submenu]').stop(true, true).slideUp(200);
    },
    openMobileMenu: function(){
        var menu = $('[data-header-mobile-menu]');

        menu.addClass('nav-mobile_open');
        $('[data-header]').addClass('open');
        $('body').addClass('menu-opened');
    },
    toggleMobileSubmenu: function(header){

        $('body').on('click', '[data-header-menu-link-toggle]', function (e) {
            if (header.hasClass('open')) {
                var _this = $(this),
                    link = _this.closest('[data-header-menu-link]').first(),
                    currSubmenu = link.siblings('[data-header-submenu]'),
                    currItem = link.closest('[data-header-menu-item]');
                
                Switcher.close();
                Pulpmill.close();
                
                if(currSubmenu.length) {
                    e.stopPropagation();
                    e.preventDefault();

                    currSubmenu.stop(true, true);
                    currSubmenu.slideToggle(200);
                    link.toggleClass("active");
                }
            }
        });
    },
    settingsSubmenuBreakpoint: function(breakpointOld, breakpointOldNew){
        if((breakpointOld == 'isDesktop' || breakpointOld == 'isDesktopHD')&&
            (breakpointOldNew == 'isTablet' || breakpointOldNew == 'isMobile')) {

            $('[data-header-submenu]').attr('style','');
            $('[data-header-menu-link]').removeClass('active');
        }

        if((breakpointOld == 'isTablet' || breakpointOld == 'isMobile')&&
            (breakpointOldNew == 'isDesktop' || breakpointOldNew == 'isDesktopHD')) {

            Nav.closeMobileMenu();
            if(!$(".js-submenu-page").isset()) {
                $('[data-header-submenu]').css("display","none");
            }
        }
    },
    setMainPadding: function(header){
        var mainBlock = $('[data-main]'),
            headerHeight = header.outerHeight();

        if(Media.detect().isDesktop){
            mainBlock.css('padding-top', headerHeight+'px');
        }else {
            mainBlock.removeAttr('style');
        }
    }
}

// // nav
$(document).ready(function ($) {
    var header = $('[data-header]');

    $('[data-header-mobile-menu]').find('.nano').nanoScroller();

    $('[data-btn-open-menu]').on('click', function(e){
        Nav.openMobileMenu();    
    });     

    $('[data-btn-close-menu]').on('click', function(){
        Nav.closeMobileMenu();
    });

    // Нужно для якорных пунктов меню
    $('body').on('click', '[data-header-menu-link]', function(){
        if(Media.detect().isTablet || Media.detect().isMobile) {
            setTimeout(function(){
                Nav.closeMobileMenu();
            }, 300);
        }
    });
    
    Nav.toggleMobileSubmenu(header);

    $('[data-header-menu]').find('[data-header-menu-item]').hover(function () {
        if (header.hasClass('open')) {
            return true;
        }
        
        clearTimeout($.data(this, 'timer'));
        //$('.nav__link',this).addClass("active");
        if(!$('.submenu', this).hasClass(".submenu_current-page")){
            $('.submenu', this).stop(true, true).slideDown(200);
            $('.submenu', this).css("top",$('.nav__list').height());
        }

    }, function () {
        if (header.hasClass('open')) {
            return true;
        }
        //$('.nav__link',this).removeClass("active");
        $.data(this, 'timer', setTimeout($.proxy(function () {
            if(!$('.submenu', this).hasClass(".submenu_current-page")){
                $('.submenu', this).stop(true, true).slideUp(200);      
            }                           
        }, this), 100));
    });

    // обрабатываем изменение точки остановки или старт страницы
    $(window).on('mdbreakpoint', function(e, breakpointOld, breakpointOldNew) {
        Nav.settingsSubmenuBreakpoint(breakpointOld, breakpointOldNew);
    });

    //Page with submenu
    if($(".js-submenu-page").isset()){

        $(".nav").addClass("nav_no-shadow");
        
        $(window).scroll(function(){
            if(Media.detect().isDesktop){
                if ($(this).scrollTop() > 0){
                    $('.nav').removeClass("nav_no-shadow");
                } else if ($(this).scrollTop() == 0) {
                    $('.nav').addClass("nav_no-shadow");
                } 
            }   
        });
    }

});

$(window).on('load', function () {
    var header = $('[data-header]');

    Nav.setMainPadding(header);
    $(window).resize(function(){
        Nav.setMainPadding(header);
    });
});


// WEBPACK FOOTER //
// ./components/nav.js